export default class TwoImageSwap {
    module: HTMLElement;
    button: HTMLElement | null;

    constructor(module: HTMLElement) {
        this.module = module;
        this.button = this.module.querySelector('[data-two-image-swap-toggle]');

        this.toggleElementsState = this.toggleElementsState.bind(this);

        this.addEventListenersToButtons();
    }

    addEventListenersToButtons() {
        if (this.button) {
            this.button.addEventListener('click', this.toggleElementsState);
        }
    }

    toggleElementsState() {
        const elements = this.module.querySelectorAll('[data-two-image-swap-toggle-state]');

        Array.from(elements).forEach(element => {
            element.getAttribute('data-active') !== null
                ? element.removeAttribute('data-active')
                : element.setAttribute('data-active', '');
        });
    }
}
